import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

class ConverterModal extends Component {
 
componentDidMount(){
    this._isMounted = true;

    
    }
      
componentWillUnmount(){
  this._isMounted = false;
}


constructor(props,context){
    super(props)
    this.state = {

        loading:true,
         
    }

  }
  
    render(){

     // let chart=this.showChart()
       
    return( 
      
      <Modal
        {...this.props}
        size="lg"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">Currency Converter</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 
        
        <div><div><iframe src="https://widget.coinlib.io/widget?type=converter&theme=dark" width="100%" height="310px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0"></iframe></div></div>
     
        <button  className="cancel2 mt-2" title="Cancel" onClick={this.props.onHide}>Close</button>
      </Modal.Body>
            
      

      </Modal>
      )
    }

}

export default ConverterModal;